import PropTypes from 'prop-types';

export default PropTypes.shape({
  sl_registration_popup_v1: PropTypes.string,
});
